const mergeParamWithPath = (path: string, param?: (string | number)[]) =>
  param ? `${path}${param.join("/")}` : path;

type ToType = (param?: (string | number)[]) => string;

export const route = {
  login: {
    to: ((param) => mergeParamWithPath("/login/", param)) as ToType,
    path: "/login/",
  },
  dashboard: {
    to: ((param) => mergeParamWithPath("/", param)) as ToType,
    path: "/",
  },
  plan: {
    to: ((param) => mergeParamWithPath("/plan/", param)) as ToType,
    path: "/plan",
    setting: {
      to: ((param) => mergeParamWithPath("/plan/setting/", param)) as ToType,
      path: "/plan/setting/:id",
    },
    paymentHistory: {
      path: "/plan/stores/:storeId/paymenthistory",
      to: (storeId: number | string) =>
        `/plan/stores/${storeId}/paymenthistory`,
    },
    paymentlog: {
      to: ((param) => mergeParamWithPath("/plan/paymentlog/", param)) as ToType,
      path: "/plan/paymentlog/:id",
    },
    payment: {
      to: ((param) => mergeParamWithPath("/plan/payment/", param)) as ToType,
      path: "/plan/payment/:id",
    },
    invoiceInfo: {
      to: ((param) =>
        mergeParamWithPath("/plan/invoiceinfo/", param)) as ToType,
      path: "/plan/invoiceinfo/:storeId",
    },
  },
  point: {
    path: "/point/stores",
    history: {
      path: "/point/stores/:storeId/history",
      to: (storeId: number | string) => `/point/stores/${storeId}/history`,
    },
    deposit: {
      path: "/point/stores/:storeId/deposit",
      to: (storeId: number | string) => `/point/stores/${storeId}/deposit`,
    },
  },
  manager: {
    path: "/managers",
    new: {
      path: "/managers/new",
    },
    edit: {
      path: "/managers/:managerId/edit",
      to: (managerId: number | string) => `/managers/${managerId}/edit`,
    },
  },
  invite: {
    to: ((param) => mergeParamWithPath("/invite/", param)) as ToType,
    path: "/invite",
    log: {
      path: "/invite/log/:id",
      to: ((param) => mergeParamWithPath("/invite/log/", param)) as ToType,
    },
  },
  salaryManagement: {
    path: "/salary-management",
  },
  download: {
    to: ((param) => mergeParamWithPath("/download/", param)) as ToType,
    path: "/download",
  },
  paymentIntegration: {
    to: ((param) =>
      mergeParamWithPath("/payment-integration/", param)) as ToType,
    path: "/payment-integration",
    overview: {
      path: "/payment-integration/overview/:id",
      to: ((param) =>
        mergeParamWithPath("/payment-integration/overview/", param)) as ToType,
    },
  },
} as const;
